import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  notificationContainer: {
    padding: theme.spacing(2),
    minWidth: 400,
    maxWidth: 450,
    backgroundColor: '#fff',
    borderRadius: 8,
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    border: '1px solid #e0e0e0'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1)
  },
  title: {
    fontWeight: 600,
    fontSize: '0.9rem',
    color: '#333'
  },
  closeButton: {
    minWidth: 'auto',
    padding: 4,
    color: '#666',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  content: {
    marginBottom: theme.spacing(2)
  },

  //dialog
  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },

  requestingUserName: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.blue_300.main
        : theme.palette.blue_500.main
  },
  message: {
    fontSize: '0.875rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  ticketText: {
    fontSize: '0.8rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  },
  ticketInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_50.main,
    padding: '8px',
    borderRadius: 8,
    border: `1px solid ${
      theme.palette.type === 'dark'
        ? theme.palette.dark_stroke.main
        : theme.palette.gray_stroke.main
    }`
  },

  queueSelection: {
    backgroundColor: theme.palette.yellow_100.main,
    padding: theme.spacing(1.5),
    borderRadius: 8
  },
  queueLabel: {
    fontSize: '0.8rem',
    fontWeight: 600,
    color: theme.palette.orange_600.main,
    marginBottom: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5)
  },
  queueSelectionError: {
    backgroundColor: theme.palette.red_50.main,
    padding: theme.spacing(1.5),
    borderRadius: 8
  },
  queueLabelError: {
    fontSize: '0.875rem',
    color: theme.palette.red_600.main,
    display: 'flex',
    alignItems: 'center',
    gap: 6
  },
  selectField: {
    width: '100%'
  },
  currentQueueChip: {
    backgroundColor: theme.palette.blue_300.main,
    color: '#fff',
    fontSize: '0.65rem',
    marginLeft: theme.spacing(1),
    padding: '0px 10px',
    borderRadius: 16
  },

  rejectButton: {
    backgroundColor: theme.palette.red_100.main,
    color: theme.palette.white_100.main,
    padding: theme.spacing(0.5, 1.5),
    borderRadius: 8,
    '&:hover': {
      backgroundColor: theme.palette.red_600.main
    }
  },

  transferButton: {
    backgroundColor: theme.palette.green_200.main,
    color: theme.palette.white_100.main,
    fontSize: '0.75rem',
    padding: theme.spacing(0.5, 1.5),
    borderRadius: 8,
    '&:hover': {
      backgroundColor: theme.palette.green_whatsApp.main
    }
  }
}))
